export default __webpack_public_path__ + "static/media/data.8683a90f.csv";